import React from 'react';
import { ProductDetailForm } from '../ProductDetailForm/ProductDetailForm';
import { ChanelQuantity } from '../ChanelProductQuantity/ChanelProductQuantity';
import { Price } from '../../../../../UI/Price/Price';
import { ChanelTitle } from '../ChanelProductTitle/ChanelProductTitle';
import { WishListMessage } from '../WishListMessage/WishListMessage';
import { AddToBrandFavorites } from '../AddToBrandFavorites/AddToBrandFavorites';
import { Quantity } from '../../../../Shared/Content/ProductDetail/ProductQuantity/ProductQuantity';

export class ChanelProductItemComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
    this.state.quantities = [];
    this.state.quantityEvents = [];
    this.state.clickedItemValue = '';
    if (
      this.props.contentData.attributes &&
      typeof this.props.contentData.attributes !== 'undefined' &&
      this.props.contentData.attributes.length > 0
    ) {
      for (var i = 0; i < this.props.contentData.attributes[0].values.length; i++) {
        this.state.quantities.push({ value: 1, errored: false });
        this.state.quantityEvents.push(undefined);
      }
    }

    this.updateAttributeAndAddToBag = this.updateAttributeAndAddToBag.bind(this);
    this.updateAttributeAndAddToWishlist = this.updateAttributeAndAddToWishlist.bind(this);
    this.updateAttributeAndAddToRegistry = this.updateAttributeAndAddToRegistry.bind(this);
    this.addToFavorites = this.addToFavorites.bind(this);
    this.updateQuantities = this.updateQuantities.bind(this);
    this.forceItemQuantity = this.forceItemQuantity.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.contentData.productId && this.props.contentData.productId != nextProps.contentData.productId) {
      this.state.quantities = [];
      this.state.quantityEvents = [];
      for (var i = 0; i < nextProps.contentData.attributes[0].values.length; i++) {
        this.state.quantities.push({ value: 1, errored: false });
        this.state.quantityEvents.push(undefined);
      }
    }
  }

  updateAttributeAndAddToBag(event) {
    var thisIndex = event.target.getAttribute('data-index');
    if (this.state.quantityEvents[thisIndex]) {
      this.props.passedFunctions.updateQuantity(this.state.quantityEvents[thisIndex]);
    } else {
      this.props.passedFunctions.updateQuantity(this.fakeQuantityObject());
    }
    let thisAttrName = '';
    Object.keys(this.props.currentAttributeState).map((key) => {
      thisAttrName = key;
    });
    this.props.passedFunctions.updateAttributeState(thisAttrName, event.target.getAttribute('data-attrval'));
    this.props.passedFunctions.ajaxAddToBag(event);
  }

  updateAttributeAndAddToWishlist(event, value) {
    let thisAttrName = '';
    Object.keys(this.props.currentAttributeState).map((key) => {
      thisAttrName = key;
    });
    this.setState({ clickedItemValue: value });

    this.props.passedFunctions.updateAttributeState(thisAttrName, event.target.getAttribute('data-attrval'));
    this.props.passedFunctions.ajaxAddToWishlist(event);
  }

  updateAttributeAndAddToRegistry(event) {
    var thisIndex = event.target.getAttribute('data-index');
    if (this.state.quantityEvents[thisIndex]) {
      this.props.passedFunctions.updateQuantity(this.state.quantityEvents[thisIndex]);
    } else {
      this.props.passedFunctions.updateQuantity(this.fakeQuantityObject());
    }
    this.props.passedFunctions.updateAttribute(event);
    this.props.passedFunctions.ajaxAddToRegistry(event);
  }

  addToFavorites(event, value) {
    // this to show the adding/removing confirmation blue box just beneath the clicked item
    this.setState({ clickedItemValue: value });
    this.props.passedFunctions.ajaxAddToBrandFavorites(event);
  }

  updateQuantities(event, index) {
    var maximumQuantity = event.target.getAttribute('data-maximum') * 1,
      minimumQuantity = event.target.getAttribute('data-minimum') * 1,
      targetValue = event.target.value || event.target.getAttribute('data-value');
    if (targetValue == null || targetValue == undefined) targetValue = '';
    let isANum = !isNaN(targetValue),
      isANum_space = isANum && targetValue.toString().indexOf(' ') > -1,
      decimalNum = targetValue.toString().indexOf('.') > -1,
      noPeriodsOrSpaces = !(isANum_space || decimalNum);
    if (
      targetValue == '' ||
      (isANum && noPeriodsOrSpaces && targetValue <= maximumQuantity && targetValue >= minimumQuantity)
    ) {
      var newQuantitiesObject = JSON.parse(JSON.stringify(this.state.quantities));
      newQuantitiesObject[index].value = targetValue;
      newQuantitiesObject[index].errored = false;
      if (event.target.getAttribute('data-value')) {
        var fakeModifiedQuantityObject = this.fakeQuantityObject();
        fakeModifiedQuantityObject.target.value = targetValue;
        this.state.quantityEvents[index] = fakeModifiedQuantityObject;
      } else {
        this.state.quantityEvents[index] = {
          target: event.target,
        };
      }
      this.setState({
        quantities: newQuantitiesObject,
      });
    }
  }

  forceItemQuantity(event, index) {
    var newQuantitiesObject = JSON.parse(JSON.stringify(this.state.quantities));
    newQuantitiesObject[index].value = 1;
    newQuantitiesObject[index].errored = false;
    if (event.target.getAttribute('data-value')) {
      var fakeModifiedQuantityObject = this.fakeQuantityObject();
      fakeModifiedQuantityObject.target.value = 1;
      this.state.quantityEvents[index] = fakeModifiedQuantityObject;
    } else {
      this.state.quantityEvents[index] = {
        target: event.target,
      };
    }
    this.setState({
      quantities: newQuantitiesObject,
    });
  }

  fakeQuantityObject() {
    return {
      target: {
        value: '1',
        getAttribute: function (attribute) {
          if (attribute == 'data-minimum') {
            return 1;
          }
          if (attribute == 'data-maximum') {
            return 3;
          }
        },
      },
    };
  }

  thisAttributeSelected(thisAttributeValue, index) {
    let thisAttrName = '';
    let attrIndex = index;
    Object.keys(this.props.currentAttributeState).map((key) => {
      thisAttrName = key;
    });
    let returnBool = false;
    if (
      this.props.currentAttributeState &&
      this.props.currentAttributeState[thisAttrName].selectedValue !== undefined
    ) {
      if (thisAttributeValue.name.toLowerCase() === this.props.currentAttributeState[thisAttrName].selectedValue) {
        returnBool = true;
      }
    } else {
      if (
        attrIndex === 0 &&
        this.props.passedFunctions.parentState.isAddToBrandFavs === true &&
        this.props.currentAttributeState.Item.selectedValue === undefined
      ) {
        returnBool = true;
      }
    }
    return returnBool;
  }

  liveChatOnClickBeauty() {
    insideAPI.post('api/visitor/set_department', { department: 'Video' });
    window.openChatButtonClick();
  }

  render() {
    var thisAttribute;

    if (
      this.props.contentData.attributes &&
      typeof this.props.contentData.attributes !== 'undefined' &&
      this.props.contentData.attributes.length > 0
    ) {
      thisAttribute = this.props.contentData.attributes[0];
    }

    return (
      <>
        {thisAttribute
          ? thisAttribute.values.map((thisAttributeValue, index) => {
              return (
                <div className='col-12 chanelItem__wrapper' key={index}>
                  <ProductDetailForm
                    currentAttributeState={this.props.currentAttributeState}
                    contentData={this.props.contentData}
                    passedFunctions={this.props.passedFunctions}
                  >
                    <div className='col-2 col-sm-2 p-l-0 chanelItemImg'>
                      <img
                        alt={
                          this.props.contentData.chanelNameFirst +
                          ' ' +
                          this.props.contentData.chanelNameSecond +
                          ' ' +
                          thisAttributeValue.name.toLowerCase()
                        }
                        src={`//dimg.dillards.com/is/image/DillardsZoom/productItem/${this.props.contentData.productNameForURL}/${thisAttributeValue.image}.jpg`}
                      />
                    </div>
                    <div className='col-4 col-sm-3 chanelItemDesc'>
                      <div className='chanelItem__name'>
                        <ChanelTitle contentData={this.props.contentData} h2='true' />
                        <span>{thisAttributeValue.name.toLowerCase()}</span>
                      </div>
                    </div>
                    <div className='col-3 col-sm-3 chanelItemPrice'>
                      <Price price={thisAttributeValue.itemPrice} />
                    </div>
                    <div className='col-12 col-sm-4 p-r-0 col-centered chanelItemShopperActions'>
                      <Quantity
                        className={this.state.quantities[index].errored ? 'errored' : ''}
                        updateQuantity={(event) => {
                          this.updateQuantities(event, index);
                        }}
                        quantity={this.state.quantities[index].value}
                        quantityErrored={this.state.quantities[index].errored}
                        contentData={this.props.contentData}
                        passedAppFunctions={this.props.passedAppFunctions}
                        isProductItem='true'
                        forceItemQuantity={(event) => {
                          this.forceItemQuantity(event, index);
                        }}
                        prodIndex={index}
                        multipleProds='yes'
                        maximumQuantity={3}
                      />
                      <button
                        role='button'
                        type='button'
                        id='add-to-bag'
                        className='btn btn-primary btn-block'
                        data-attrtype={this.props.fromNameVals}
                        data-attrval={thisAttributeValue.name.toLowerCase()}
                        data-attrid={thisAttribute.attrId}
                        data-val={thisAttributeValue.name.toLowerCase()}
                        data-index={index}
                        onClick={this.updateAttributeAndAddToBag}
                      >
                        Add To Bag
                      </button>
                      {this.props.contentData.superCat == 'Beauty' ? (
                        <button
                          className='btn btn-secondary btn-block beauty-chat'
                          role='button'
                          type='button'
                          onKeyPress={this.liveChatOnClickBeauty}
                          onClick={this.liveChatOnClickBeauty}
                          manual_cm_sp='video+chat-_-beauty-_-product'
                        >
                          <span className='sr-only'>Opens a simulated dialog</span>
                          Chat with a Beauty Expert
                        </button>
                      ) : (
                        ''
                      )}
                      {this.state.clickedItemValue === thisAttributeValue.value ? (
                        <WishListMessage
                          passedFunctions={this.props.passedFunctions}
                          passedAppFunctions={this.props.passedAppFunctions}
                        />
                      ) : null}
                      {!this.props.passedAppFunctions.isInternational() ? (
                        <button
                          role='button'
                          type='button'
                          id='add-to-wishlist'
                          className='btn btn-block btn-tertiary'
                          data-val={thisAttributeValue.name.toLowerCase()}
                          data-attrval={thisAttributeValue.name.toLowerCase()}
                          data-attrid={thisAttribute.attrId}
                          data-index={index}
                          onClick={(e) => this.updateAttributeAndAddToWishlist(e, thisAttributeValue.value)}
                        >
                          <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 15.58 12.44'>
                            <title>heart</title>
                            <g data-name='Layer 2'>
                              <g data-name='Layer 1'>
                                <path
                                  className='cls-1'
                                  d='M7.79,12.44a.54.54,0,0,1-.32-.11L1.66,7.46l0,0A4.78,4.78,0,0,1,0,4.14,4.15,4.15,0,0,1,4.14,0,4.13,4.13,0,0,1,7.82,2.14,4.19,4.19,0,1,1,14.3,7.33l-6.19,5A.5.5,0,0,1,7.79,12.44ZM2.32,6.71,7.8,11.29l5.84-4.71a3.15,3.15,0,0,0-2.21-5.4,3,3,0,0,0-3.08,2.4.51.51,0,0,1-.07.17A.64.64,0,0,1,7.83,4a.5.5,0,0,1-.44-.18,1.3,1.3,0,0,1-.14-.29A3,3,0,0,0,4.14,1,3.15,3.15,0,0,0,1,4.14,3.66,3.66,0,0,0,2.32,6.71Z'
                                />
                              </g>
                            </g>
                          </svg>
                          Add To Wish List
                        </button>
                      ) : (
                        ''
                      )}
                      <AddToBrandFavorites
                        passedAppFunctions={this.props.passedAppFunctions}
                        contentData={this.props.contentData}
                        passedFunctions={this.props.passedFunctions}
                        passedOnClick={(e) => {
                          this.addToFavorites(e, thisAttributeValue.value);
                        }}
                        passedDataIds={{
                          'data-attrval': thisAttributeValue.value,
                          'data-attrid': thisAttribute.attrId,
                          'data-index': index,
                        }}
                        dataAttrItem={thisAttributeValue.name.toLowerCase()}
                      />
                    </div>
                  </ProductDetailForm>
                </div>
              );
            })
          : ''}
      </>
    );
  }
}

export default ChanelProductItemComponent;
